import { requestService } from "../../services/helpers/request.service";

export const partnerService = {
    getFiles,
    getDoctors,
    getMMDoctors,
    getUserInfo,
    getInternalDoctors,
    getExternalDoctors,
    getLocations,
    getSpecialLocations,
    getLocationsSpecialCons,
    saveDoctor,
    savePatient,
    uploadFile,
    updateUserInfo,
    formExists,
    getIncreasePercentage,
    deleteDoctor,
    getPatientInvestigations,
    deleteFile,
    getStenciel
    
}

function getFiles(params) {
    return requestService.get({
        methodName: '/Partner/GetFiles',
        queryString: params
    });
}

function getDoctors(params) {
    return requestService.get({
        methodName: '/Partner/GetDoctors',
        queryString: params
    });
}

function getMMDoctors(params) {
    return requestService.get({
        methodName: '/Partner/GetMMDoctors',
        queryString: params
    });
}

function getInternalDoctors(params) {
    return requestService.get({
        methodName: '/Partner/GetInternalDoctors',
        queryString: params
    });
}

function getExternalDoctors(params) {
    return requestService.get({
        methodName: '/Partner/GetExternalDoctors',
        queryString: params
    });
}

function getLocations(params) {
    return requestService.get({
        methodName: '/Partner/GetLocations',
        queryString: params
    });
}

function getSpecialLocations(params) {
    return requestService.get({
        methodName: '/Partner/GetSpecialLocations',
        queryString: params
    });
}

function getLocationsSpecialCons(params) {
    return requestService.get({
        methodName: '/Partner/GetLocationsSpecialCons',
        queryString: params
    });
}

function formExists(params) {
    return requestService.get({
        methodName: '/Partner/FormExists',
        queryString: params
    });
}

function getIncreasePercentage(params) {
    return requestService.get({
        methodName: '/Partner/GetIncreasePercentage',
        queryString: params
    });
}

function getUserInfo( params) {
    return requestService.get({
        methodName: '/Partner/GetUserInfo',
        queryString: params
    });
}

function saveDoctor(params) {
    return requestService.post({
        methodName: '/Partner/SaveDoctor',
        body: params
    });
}


function savePatient(params) {
    return requestService.post({
        methodName: '/Partner/SavePatient',
        body: params
    });
}


function uploadFile(params) {
    return requestService.formData({
        methodName: '/Partner/UploadFile',
        body: params
    });
}

function updateUserInfo(params) {
    return requestService.post({
        methodName: '/Partner/SaveUserInfo',
        body: params
    });
}

function getPatientInvestigations(params) {
    return requestService.get({
        methodName: '/Partner/GetPatientInvestigations',
        queryString: params
    });
}


function deleteDoctor(params) {
return requestService.get({
        methodName: '/Partner/DeleteDoctor',
        queryString: params
    });
}

function deleteFile(params) {
    return requestService.get({
        methodName: '/Partner/DeleteFile',
        queryString: params
    });
} 

function getStenciel(params) {
    return requestService.get({
        methodName: '/Partner/GetStenciel',
        queryString: params
    });
} 


